import { render, staticRenderFns } from "./SponsorEuCard.vue?vue&type=template&id=21b98bec&scoped=true&"
import script from "./SponsorEuCard.vue?vue&type=script&lang=js&"
export * from "./SponsorEuCard.vue?vue&type=script&lang=js&"
import style0 from "./SponsorEuCard.vue?vue&type=style&index=0&id=21b98bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b98bec",
  null
  
)

export default component.exports